module.exports = __webpack_public_path__ + "static/media/2.0803fff8.jpg";